import { render, staticRenderFns } from "./ResourcesPanel.vue?vue&type=template&id=1ab7ee6b&scoped=true&"
import script from "./ResourcesPanel.vue?vue&type=script&lang=js&"
export * from "./ResourcesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab7ee6b",
  null
  
)

export default component.exports